import React, { useEffect, useState, useContext } from "react";
import SearchBar from "../../common/searchBar";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const BlogProfileNav = ({ value, handleSearch, user }) => {
  const [option, setOption] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    setOption(event.target.value);
    console.log(`?sortBy=${event.target.value}`);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <div className={`d-flex justify-content-between pt-4 mt-1`}>
        <div style={{ marginTop: 20 }}>
          <SearchBar value={value} handleSearch={handleSearch}></SearchBar>
        </div>
        <div>
          <FormControl style={{ minWidth: 120 }}>
            <InputLabel id="user-blog-search">Sort by</InputLabel>
            <Select
              labelId="user-blog-search"
              id="user-blog-search"
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={option}
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={"newest"}>Newest</MenuItem>
              <MenuItem value={"mostViewed"}>Most Viewed</MenuItem>
              <MenuItem value={"ratings"}>Ratings</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default BlogProfileNav;
